import LocaleProvider, { Locale } from 'antd/lib/locale-provider'
import * as Raven from 'raven-js'
import * as React from 'react'
import { IntlProvider } from 'react-intl'

import ErrorPage from './../ErrorPage'

interface IntlProps {
  ANT_DESIGN: Locale
}

interface State {
  i18nMessages: IntlProps | undefined | null
}

interface Props {
  children?: React.ReactElement<{}>
  locale: string
}

class StockDataProvider extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      i18nMessages: undefined,
    }
  }

  public async componentDidMount(): Promise<void> {
    try {
      const response = await fetch(`/i18n/${this.props.locale}.json`)
      if (response.ok) {
        // http status 200-299 = OK
        this.setState({ i18nMessages: await response.json() })
      } else {
        throw new Error(response.statusText)
      }
    } catch (error) {
      this.setState({ i18nMessages: null })
      Raven.captureException(error)
    }
  }

  public render() {
    const { i18nMessages } = this.state
    const { children, locale } = this.props

    // i18n messages has not loaded.
    if (i18nMessages === undefined) {
      return null
    }

    // i18n messages failed to load.
    if (i18nMessages === null) {
      return <ErrorPage message="Locale file failed to fetch." />
    }

    // i18n messages is ready.
    return (
      <IntlProvider locale={locale} messages={i18nMessages} textComponent={React.Fragment}>
        <LocaleProvider locale={i18nMessages.ANT_DESIGN}>{children}</LocaleProvider>
      </IntlProvider>
    )
  }
}

export default StockDataProvider



// WEBPACK FOOTER //
// ./src/components/StockDataProvider/StockDataProvider.tsx